/*eslint id-length: 0 */
import _ from '../i18n.jsx';
const ancestriesList = [
    { name: _('African'), code: '', value: 566 },
    { name: _('African American'), code: '', value: 498 },
    { name: _('Albanian'), code: '', value: 537 },
    { name: _('American'), code: '', value: 507 },
    { name: _('American Indian'), code: '', value: 529 },
    { name: _('Arab'), code: '', value: 477 },
    { name: _('Armenian'), code: '', value: 538 },
    { name: _('Ashkenazi Jewish'), code: '', value: 539 },
    { name: _('Asian'), code: '', value: 506 },
    { name: _('Asian Indian'), code: '', value: 530 },
    { name: _('Austrian'), code: '', value: 508 },
    { name: _('Bahraini'), code: '', value: 10000009 },
    { name: _('Belgian'), code: '', value: 478 },
    { name: _('Black/African'), code: '', value: 505 },
    { name: _('Brazilian'), code: '', value: 540 },
    { name: _('British'), code: '', value: 509 },
    { name: _('Cajun'), code: '', value: 479 },
    { name: _('Cambodian'), code: '', value: 541 },
    { name: _('Canadian'), code: '', value: 510 },
    { name: _('Chinese'), code: '', value: 500 },
    { name: _('Colombian'), code: '', value: 480 },
    { name: _('Croatian'), code: '', value: 542 },
    { name: _('Cuban'), code: '', value: 543 },
    { name: _('Cypriot'), code: '', value: 10000010 },
    { name: _('Czech'), code: '', value: 511 },
    { name: _('Czechoslovakian'), code: '', value: 481 },
    { name: _('Danish'), code: '', value: 544 },
    { name: _('Dominican'), code: '', value: 512 },
    { name: _('Dutch'), code: '', value: 482 },
    { name: _('Ecuadorian'), code: '', value: 545 },
    { name: _('Egyptian'), code: '', value: 513 },
    { name: _('English'), code: '', value: 483 },
    { name: _('European'), code: '', value: 546 },
    { name: _('Filipino'), code: '', value: 569 },
    { name: _('Filipino'), code: '', value: 547 },
    { name: _('Finnish'), code: '', value: 514 },
    { name: _('French'), code: '', value: 484 },
    { name: _('French Canadian'), code: '', value: 548 },
    { name: _('German'), code: '', value: 515 },
    { name: _('Greek'), code: '', value: 485 },
    { name: _('Guamanian'), code: '', value: 503 },
    { name: _('Guatemalan'), code: '', value: 549 },
    { name: _('Guyanese'), code: '', value: 573 },
    { name: _('Haitian'), code: '', value: 516 },
    { name: _('Hawaiian'), code: '', value: 499 },
    { name: _('Hispanic'), code: '', value: 486 },
    { name: _('Hmong'), code: '', value: 531 },
    { name: _('Honduran'), code: '', value: 550 },
    { name: _('Hungarian'), code: '', value: 551 },
    { name: _('Iranian'), code: '', value: 517 },
    { name: _('Iraqi'), code: '', value: 10000001 },
    { name: _('Irish'), code: '', value: 487 },
    { name: _('Israeli'), code: '', value: 552 },
    { name: _('Italian'), code: '', value: 518 },
    { name: _('Jamaican'), code: '', value: 534 },
    { name: _('Japanese'), code: '', value: 501 },
    { name: _('Jordanian'), code: '', value: 10000004 },
    { name: _('Korean'), code: '', value: 570 },
    { name: _('Kuwaiti'), code: '', value: 10000007 },
    { name: _('Laotian'), code: '', value: 571 },
    { name: _('Latin American'), code: '', value: 488 },
    { name: _('Lebanese'), code: '', value: 553 },
    { name: _('Lithuanian'), code: '', value: 519 },
    { name: _('Mexican'), code: '', value: 489 },
    { name: _('Native American'), code: '', value: 475 },
    { name: _('Nicaraguan'), code: '', value: 554 },
    { name: _('Nigerian'), code: '', value: 567 },
    { name: _('Northern European'), code: '', value: 555 },
    { name: _('Norwegian'), code: '', value: 520 },
    { name: _('Omani'), code: '', value: 10000006 },
    { name: _('Other/Mixed'), code: '', value: 476 },
    { name: _('Pacific Islander'), code: '', value: 536 },
    { name: _('Pakistani'), code: '', value: 504 },
    { name: _('Palestinian'), code: '', value: 10000005 },
    { name: _('Panamanian'), code: '', value: 574 },
    { name: _('Pennsylvania German'), code: '', value: 490 },
    { name: _('Peruvian'), code: '', value: 556 },
    { name: _('Polish'), code: '', value: 521 },
    { name: _('Portuguese'), code: '', value: 491 },
    { name: _('Puerto Rican'), code: '', value: 557 },
    { name: _('Qatari'), code: '', value: 10000008 },
    { name: _('Romanian'), code: '', value: 522 },
    { name: _('Russian'), code: '', value: 492 },
    { name: _('Salvadoran'), code: '', value: 558 },
    { name: _('Samoans'), code: '', value: 568 },
    { name: _('Saudi Arabian'), code: '', value: 10000002 },
    { name: _('Scandinavian'), code: '', value: 559 },
    { name: _('Scotch-Irish'), code: '', value: 523 },
    { name: _('Scottish'), code: '', value: 493 },
    { name: _('Sephardic Jewish'), code: '', value: 560 },
    { name: _('Serbian'), code: '', value: 524 },
    { name: _('Slavic'), code: '', value: 494 },
    { name: _('Slovak'), code: '', value: 561 },
    { name: _('Slovene'), code: '', value: 525 },
    { name: _('Southeast Asian'), code: '', value: 532 },
    { name: _('Spaniard'), code: '', value: 495 },
    { name: _('Spanish'), code: '', value: 562 },
    { name: _('Swedish'), code: '', value: 563 },
    { name: _('Swiss'), code: '', value: 526 },
    { name: _('Syrian'), code: '', value: 496 },
    { name: _('Taiwanese'), code: '', value: 502 },
    { name: _('Thai'), code: '', value: 572 },
    { name: _('Turkish'), code: '', value: 564 },
    { name: _('Ukrainian'), code: '', value: 527 },
    { name: _('Vietnamese'), code: '', value: 533 },
    { name: _('Welsh'), code: '', value: 497 },
    { name: _('West Indian'), code: '', value: 575 },
    { name: _('Western European'), code: '', value: 565 },
    { name: _('White/Caucasian'), code: '', value: 535 },
    { name: _('Yemeni'), code: '', value: 10000003 },
    { name: _('Yugoslavian'), code: '', value: 528 }
];
export default ancestriesList;
